export const FREE_WORD_LIST = [
  { id: 1, value: '口コミ', checked: false },
  { id: 2, value: '外壁材', checked: false },
  { id: 3, value: 'おすすめ', checked: false },
  { id: 4, value: 'おしゃれ', checked: false },
  { id: 5, value: '評判が良い', checked: false },
  { id: 6, value: '長持ち', checked: false },
  { id: 7, value: 'アフターフォロー', checked: false },
  { id: 8, value: '暑くない', checked: false },
  { id: 9, value: 'カラーシミュレーター', checked: false },
  { id: 10, value: '塗料', checked: false },
  { id: 11, value: 'カバー工法', checked: false },
  { id: 12, value: '屋根材', checked: false },
];
